export default __webpack_public_path__ + "static/media/SHA.6fbe1cb5.png";